import { call, put, select, takeEvery } from "redux-saga/effects"

import { genericGetRequest_2, genericPostRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"
import { GET_CLIENT_CAMPAIGN_FULFILLMENT, EXPORT_CLIENT_CAMPAIGN_FULFILLMENT } from "./actionTypes";
import {
  getClientCampaignFulfillmentError,
  getClientCampaignFulfillmentSuccess,
  exportClientCampaignFulfillmentError,
  exportClientCampaignFulfillmentSuccess,
} from "./actions";
import { buildCampaignFulfillmentCacheKey } from "helpers/campaign_fulfillment_pagination_helper";
import { bsh_getClientUserDetails, bsh_isAdminUserDetailsPresent } from "helpers/sf_browser_storage_helper";
import ToastAlert, { ToastAlertIconType } from "components/Common/ToastAlert/ToastAlert";
import { showExportEnqueuedToast } from "helpers/export_toast_helper";

const inFlightClientCampaignFulfillmentRequests = new Set()

function* OnGetClientCampaignFulfillment(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser"));
    const {token, account_id} = user.user;
    const queryParams = action?.payload?.queryParams || action?.payload;
    const useCache = Boolean(action.payload?.useCache)
    const requestedPageNumber = parseInt(queryParams?.page_number, 10) || 1
    const cacheKey = useCache ? buildCampaignFulfillmentCacheKey(queryParams) : null
    const requestKey = `${cacheKey}:${requestedPageNumber}`
    const cachedPage = useCache
      ? yield select((state) => state.ClientCampaignFulfillment.page_cache?.[cacheKey]?.[requestedPageNumber])
      : null

    if (useCache && cachedPage) {
      return
    }

    if (useCache && inFlightClientCampaignFulfillmentRequests.has(requestKey)) {
      return
    }

    if (useCache) {
      inFlightClientCampaignFulfillmentRequests.add(requestKey)
    }

    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/campaign_fulfillment`,
      queryParams,
      {
        Authorization: token,
        'account-id': account_id,
      }
    )
    yield put(getClientCampaignFulfillmentSuccess(response, {
      queryParams,
      appendResults: Boolean(action.payload?.appendResults),
      useCache,
    }))
  } catch (error) {
    yield put(getClientCampaignFulfillmentError(error))
  } finally {
    if (action.payload?.useCache) {
      const queryParams = action?.payload?.queryParams || action?.payload
      const requestedPageNumber = parseInt(queryParams?.page_number, 10) || 1
      const cacheKey = buildCampaignFulfillmentCacheKey(queryParams)
      inFlightClientCampaignFulfillmentRequests.delete(`${cacheKey}:${requestedPageNumber}`)
    }
  }
}


function* OnExportClientCampaignFulfillment(action) {
  const user = bsh_getClientUserDetails();
  const queryParams = action?.payload?.queryParams || action?.payload || {};
  const req = {
    body: JSON.stringify(queryParams),
    headers: {
      Authorization: user.token,
      'account-id': user.account_id,
      'Content-Type': 'application/json',
    },
  }
  try {
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/campaign_fulfillment/export`,
      req,
    )
    yield put(exportClientCampaignFulfillmentSuccess(response))
    showExportEnqueuedToast({ reportExportsAvailable: bsh_isAdminUserDetailsPresent() })
  } catch (error) {
    yield put(exportClientCampaignFulfillmentError(error))
    ToastAlert.fire({ icon: ToastAlertIconType.ERROR, title: "Failed to queue campaign fulfillment export." })
  }
}


function* ClientCampaignFulfillmentSaga() {
  yield takeEvery(GET_CLIENT_CAMPAIGN_FULFILLMENT, OnGetClientCampaignFulfillment)
  yield takeEvery(EXPORT_CLIENT_CAMPAIGN_FULFILLMENT, OnExportClientCampaignFulfillment)

}

export default ClientCampaignFulfillmentSaga;
